/**
 * Indexer API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
package indexer.codegen

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

/**
 *
 * Values: MANUAL,US_GEO,CA_GEO,GB_GEO,SANCTIONED_GEO,COMPLIANCE_PROVIDER
 */
@JsExport
@Serializable
enum class IndexerComplianceReason(val value: kotlin.String) {
    MANUAL("MANUAL"), // :/
    US_GEO("US_GEO"), // :/
    CA_GEO("CA_GEO"), // :/
    GB_GEO("GB_GEO"), // :/
    SANCTIONED_GEO("SANCTIONED_GEO"), // :/
    COMPLIANCE_PROVIDER("COMPLIANCE_PROVIDER"); // :/
}
